import React, { useState, Dispatch, SetStateAction, useMemo } from 'react';
import { Modal, Row } from 'antd';
import { Button, MasterDetailForm, Widget, notification } from '@digital/ui';
import { StepsTimeline, getStatusOrdemCompraFluxo } from '@app/api/status';
import { ajustarProxStepByAPIState, ajustarStepOnReloadState, dadosGeraisState, fluxoProcessoState, ordemCompraIdState, ordemCompraRodadaNegociacaoIdState, proxStepState, reloadDadosGeraisState, reloadState, reloadVendorListState, reloadWidgetTimelineState, stepState } from '../atoms';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { avancarOrdemCompra } from '@app/api/sas/ordemCompra';
import { Visibility } from '@app/components';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';

interface Props {
  setExibirModalAprovacaoProponentes: Dispatch<SetStateAction<boolean>>;
}

const { confirm } = Modal;

const ModalAvancar = ({ setExibirModalAprovacaoProponentes }: Props) => {
  const [exibirModal, setExibirModal] = useState(false);
  let msgDefault = `Deseja avançar a etapa Ordem de Compra?`;
  const [mensagemConfirmacao, setMensagemConfirmacao] = useState(msgDefault);

  // const ordemCompraRodadaNegociacaoId = useRecoilValue(ordemCompraRodadaNegociacaoIdState);
  const fluxo = useRecoilValue(fluxoProcessoState);
  const [step, setStep] = useRecoilState(stepState);

  const proxStep = useRecoilValue(proxStepState);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const [reloadTimeline, setReloadTimeline] = useRecoilState(reloadWidgetTimelineState);
  const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const [ajustarStepOnReload, setAjustarStepOnReload] = useRecoilState(ajustarStepOnReloadState);

  const setAjustarProxStepByAPI = useSetRecoilState(ajustarProxStepByAPIState);

  const ordemCompraId = useRecoilValue(ordemCompraIdState);

  const onSetStep = (stepTmp: StepsTimeline) => {
    if (stepTmp) {
      setStep(stepTmp);
    }

    setReloadVendorList(!reloadVendorList);
    setReloadTimeline(!reloadTimeline);
    setReloadDadosGerais(!reloadDadosGerais);
  };

  const onDiscordar = () => {
    setExibirModal(false);
  };

  const etapasNaoVisiveis: string[] = [EGuidFluxoProcessoEtapa.EnviaCartaAgradecimento, EGuidFluxoProcessoEtapa.ConclusaoDoProcessoStep];

  const onConcordar = () => {

    avancarOrdemCompra(ordemCompraId, {
      ordemCompraRodadaNegociacaoId: step.ordemCompraRodadaNegociacaoId,
      fluxoProcessoId: step.fluxoEtapaId
    })
      .then((data: any) => {
        if (data.notifications && data.notifications.length > 0) {
          const etapaDesatualizada = data.notifications.find((not: { property: string; message: string }) => not.property === 'EtapaDesatualizada');
          if (etapaDesatualizada) {
            setExibirModal(false);
            return;
          }
        }

        setReloadTimeline(!reloadTimeline);
        return data;
      }).then((data: any) => {

        if (data.valid) {
          onSetStep(proxStep);
        } else {
          if (data.notifications && data.notifications.length > 0) {
            data.notifications.map((notification: { property: string; }) => {
              if (notification.property === 'NecessitaAprovacaoGestorProponentes' && data.notifications.length === 1) {
                setExibirModalAprovacaoProponentes(true);
                setExibirModal(false);
              }
            });
          }
        }
        setExibirModal(false);

      });

  };

  const avancarBotao = () => {
    setExibirModal(true);
    setAjustarStepOnReload(true);
  };

  const avancarSemModal = () => {
    setAjustarStepOnReload(false);

    if (isObjNotEmpty(step.ordemCompraRodadaNegociacaoId) || isObjNotEmpty(step.children)) {
      onSetStep(proxStep);
    } else {
      setAjustarProxStepByAPI(true);

      if (!ordemCompraId || !step || isObjEmpty(step)) return;

      avancarOrdemCompra(ordemCompraId, {
        ordemCompraRodadaNegociacaoId: step.ordemCompraRodadaNegociacaoId,
        fluxoProcessoId: step.fluxoEtapaId,
        pularProximaEtapa: true,
        validacaoSomente: true
      })
        .then((data: any) => {
          if (data) {
            if (data.notifications && data.notifications.length > 0) {
              data.notifications.map((not: { property: string; message: string; }) => {
                if (not.property === 'NecessitaAprovacaoGestorProponentes') {
                  setExibirModalAprovacaoProponentes(true);
                  return;
                }

                // if (not.property === 'SasStatusDocumentoOrdemCompra') {
                //   notification.error(not.message);
                // }

                // if (not.property === 'BidCycleItemOcV3') {
                //   notification.error(not.message);
                // }

              });
            }

            if (data.valid) {
              onSetStep(step);
            }
          }
        });
    }

  };

  function avancarModalEhVisivel(): boolean | undefined {
    const a = etapasNaoVisiveis.includes(step.fluxoEtapaId) == false; // etapas nao mostra
    const b = (isObjNotEmpty(fluxo)
      && isObjNotEmpty(step.fluxoEtapaId) 
      && 'fluxoEtapaId' in step
      && fluxo === step.fluxoEtapaId 
      && (step.isRealizado == false 
        || (step.isAtual == true 
          && step.isRealizado == true))
      ); //passo atual já realizado

    const c = ('status' in step
      ? step.status === "Preenchendo" && proxStep && 'status' in proxStep && proxStep.status != ""
      : false) || false; // preenchendo sendo o ultimo
    const d = isObjEmpty(fluxo); //passo 1
    const e = isObjNotEmpty(step);
    // console.log("1avancarModalEhVisivel", a, b, c, d, e);

    return e && a && (b || c || d);
  }

  function avancarSemModalEhVisivel(): boolean | undefined {

    const a = isObjNotEmpty(step);
    const b = ('status' in step
      ? step.status !== "Preenchendo" && proxStep && 'status' in proxStep && proxStep.status != ""
      : false) || false; //preenchendo sendo um fluxo no meio
    const c = etapasNaoVisiveis.includes(step.fluxoEtapaId) == false; // etapas nao mostra
    const d = isObjNotEmpty(fluxo) &&
      (isObjNotEmpty(step.fluxoEtapaId) && 'fluxoEtapaId' in step) && fluxo !== step.fluxoEtapaId || fluxo == EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao;
    // passo atual
    // console.log("2avancarSemModalEhVisivel", a, b, c, d);

    return (a && b && c && d);
  }


  var buttonsAvancar = useMemo(() => {

    return (
      <>
      <Visibility visible={
        dadosGerais.consultiva && step.ordem >= 21 ? false : true
      }>
        <Visibility
          visible={
            avancarSemModalEhVisivel()
          }>
          <Button title='Avançar' type='primary' onClick={() => avancarSemModal()} />
        </Visibility>

        <Visibility
          visible={
            avancarModalEhVisivel()
          }>
          <Button type="success" onClick={avancarBotao}>
            Avançar
          </Button>
        </Visibility>
      </Visibility>

        <Visibility visible={exibirModal}>
          <Modal title="Avançar" width="680px" visible={exibirModal} onCancel={() => setExibirModal(false)} footer={null}>
            <MasterDetailForm
              actions={[
                <Button key="discordarBtn" type="link" onClick={() => onDiscordar()}>
                  Não
                </Button>,
                <Button key="concordarBtn" type="primary" onClick={() => onConcordar()}>
                  Sim
                </Button>,
              ]}>
              <Widget>
                <Row>
                  <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>{mensagemConfirmacao}</p>
                </Row>
              </Widget>
            </MasterDetailForm>
          </Modal>
        </Visibility>
      </>
    );
  }, [step, fluxo, exibirModal, mensagemConfirmacao, reloadDadosGerais, reloadVendorList, reloadTimeline, proxStep]);

  return (
    <>
      {buttonsAvancar}
    </>
  );
};
export default ModalAvancar;
